import React from "react";
import { Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const ReArrange = ({ currentActivity, rearrangeSelections }) => {
  console.log("Activity:", currentActivity);
  console.log("User Selections:", rearrangeSelections);

  // Get user's selected sentence (default to empty string to prevent errors)
  const userSentence =
    rearrangeSelections[currentActivity.ContentId]?.trim() || "";

  // Retrieve the correct sentence from Options (assuming it's stored in an array)
  const correctSentence = currentActivity.Options?.[0]?.Value?.trim() || ""; // Ensure it's the first option

  // Check if the answer is correct (no need to reverse for Arabic)
  const isCorrect = userSentence === correctSentence;

  return (
    <>
      {isCorrect ? (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "green",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Correct Answer!
          </Typography>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CancelIcon sx={{ fontSize: 40, color: "red" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "red",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Incorrect Answer!
          </Typography>
        </>
      )}

      {currentActivity.Options?.some((option) => option.Rationale?.Text) ? (
        currentActivity.Options.map((option, index) => {
          const rationaleText = option.Rationale?.Text?.trim();
          const rationaleContentId = option.Rationale?.ContentId?.trim();

          return (
            <Typography
              key={index}
              sx={{
                marginTop: 1,
                fontSize: "0.75rem",
                color: "text.secondary",
                padding: "8px",
                margin: "8px 0",
              }}
            >
              {rationaleText
                ? `Rationale: ${rationaleText}`
                : rationaleContentId
                ? `Rationale ID: ${rationaleContentId}`
                : "No rationale available."}
            </Typography>
          );
        })
      ) : (
        <Typography
          sx={{
            fontSize: "0.9rem",
            fontStyle: "italic",
            color: "#999",
            marginTop: 1,
          }}
        >
          Rationale: Not available
        </Typography>
      )}
    </>
  );
};

export default ReArrange;
